/**
 * 房间关闭错误页面
 * 当房间编码无效或不存在时显示
 */
export default function Page() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <div className="text-6xl mb-4">🚫</div>
        <h1 className="text-2xl font-bold text-gray-800 mb-2">房间关闭</h1>
        <p className="text-gray-500">请联系管理员获取有效的房间链接</p>
      </div>
    </div>
  );
}
